module.exports = __webpack_public_path__ + "img/klfg.841a435d.jpg";